module.exports = __webpack_public_path__ + "img/minip_app_image_scan.8c1bf202.png";